// extracted by mini-css-extract-plugin
module.exports = {"placeholder-container":"Placeholder_placeholder-container__2DP0D","placeholder":"Placeholder_placeholder__fGVTy"};